import React, { useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { CiEdit } from "react-icons/ci";
import { MdDeleteSweep } from "react-icons/md";
import AddEditPopup from './AddEditPopup';
import { formatDate } from '../../utils/Utils';
import { BeatLoader } from "react-spinners";
import AddEditOrganizationPopup from './AddEditOrganizationPopup';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import UpdateIndustry from '../Industry/UpdateIndustry';
import { useFetchIndustryTable, useDeleteIndustry } from "../../hooks/useIndustry";
import Swal from 'sweetalert2'
function IndustryTable({ industriesType, setIndustriesType, filteredData, setFilteredData }) {
    const [showPopup, setShowPopup] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [expandedCustomers, setExpandedCustomers] = useState({}); // State to manage expanded steps for each customer

    // Custom hook for fetching users
    const { data, error, isLoading } = useFetchIndustryTable(industriesType, filteredData);


    // Custom hook for delete mutation

    const deleteIndustryMutation = useDeleteIndustry();

    const handleEdit = (id, customer) => {
        // const customer = data.users.find(c => c.id === id);
        setSelectedCustomer(customer);
        setShowPopup(true);
    };
    const handleClose = () => {
        setShowPopup(false);
    };
    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to undo this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteIndustryMutation.mutate(id);
                    Swal.fire({
                        title: "Removed!",
                        text: "The customer journey has been successfully removed.",
                        icon: "success",
                    });
                } catch (error) {
                    Swal.fire({
                        title: "Error!",
                        text: "An unexpected error occurred. Please try again later.",
                        icon: "error",
                    });
                    console.error("Error removing customer journey:", error);
                }
            }
        });
    };


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const toggleSteps = (customerId) => {
        setExpandedCustomers((prev) => ({
            ...prev,
            [customerId]: !prev[customerId], // Toggle the expanded state for this customer
        }));
    };

    if (isLoading) return <div className='col-span-full flex justify-center items-center'><BeatLoader /></div>;
    if (error) return <div className='col-span-full flex justify-center items-center'>Error loading Customer Journey</div>;

    return (
        <div className="col-span-full bg-white shadow-xl rounded-2xl border border-slate-200">
        <header className="px-6 py-4 border-b border-slate-100 bg-slate-50 rounded-t-2xl">
          <h2 className="text-xl font-bold text-slate-800">Industries</h2>
        </header>
      
        <div className="p-6">
          <div className="overflow-x-auto">
            <table className="table-auto w-full text-left">
              <thead className="text-xs font-semibold uppercase text-slate-500 bg-slate-100 rounded">
                <tr>
                  <th className="p-4">Name</th>
                  <th className="p-4">SubIndustries</th>
                  <th className="p-4 text-center">Actions</th>
                </tr>
              </thead>
      
              <tbody className="text-sm text-slate-700 divide-y divide-slate-100">
                {data?.map((customer) => (
                  <tr key={customer.id} className="hover:bg-slate-50 transition">
                    <td className="p-4 max-w-xs">
                      <span className="block font-medium truncate">{customer?.name}</span>
                    </td>
      
                    <td className="p-4 max-w-md">
                      <ul className="list-disc list-inside space-y-1">
                        {customer?.subIndustries
                          ?.slice(0, expandedCustomers[customer.id] ? customer.subIndustries.length : 2)
                          .map((sub, index) => (
                            <li key={index}>{sub}</li>
                          ))}
                      </ul>
      
                      <button
                        className="text-blue-600 hover:text-blue-800 text-sm mt-2 flex items-center gap-1"
                        onClick={() => toggleSteps(customer.id)}
                      >
                        {expandedCustomers[customer.id] ? (
                          <>
                            <FaChevronUp className="text-sm" /> Show less
                          </>
                        ) : (
                          <>
                            <FaChevronDown className="text-sm" /> Show more
                          </>
                        )}
                      </button>
                    </td>
      
                    <td className="p-4 text-center">
  <div className="flex justify-center items-center gap-4">
    {/* Bouton Éditer */}
    <button
      onClick={() => handleEdit(customer.id, customer)}
      title="Edit"
      className="transition-transform duration-150 hover:scale-110"
    >
      <CiEdit className="w-6 h-6 text-green-600" />
    </button>

    {/* Bouton Supprimer */}
    <button
      onClick={() => handleDelete(customer.id)}
      title="Delete"
      className="transition-transform duration-150 hover:scale-110"
    >
      <MdDeleteSweep className="w-6 h-6 text-red-600" />
    </button>
  </div>
</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
      
          {showPopup && (
            <UpdateIndustry handleClose={handleClose} selectedCustomer={selectedCustomer} />
          )}
        </div>
      </div>
      
    );
}

export default IndustryTable;
